/**
 * Frontend API service for the Weekly Performance Reporting System.
 * All calls go through Firebase Cloud Functions (which talk to Supabase server-side).
 * Supabase is NEVER accessed directly from the frontend.
 */
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

export const submitWeeklyReport = async (reportData) => {
  const fn = httpsCallable(functions, 'submitWeeklyReport');
  const result = await fn(reportData);
  return result.data;
};

export const getCurrentWeekReport = async () => {
  const fn = httpsCallable(functions, 'getCurrentWeekReport');
  const result = await fn();
  return result.data;
};

export const getMyReports = async () => {
  const fn = httpsCallable(functions, 'getMyReports');
  const result = await fn();
  return result.data;
};

export const getAllReports = async (filters = {}) => {
  const fn = httpsCallable(functions, 'getAllReports');
  const result = await fn(filters);
  return result.data;
};

export const getLeaderboard = async () => {
  const fn = httpsCallable(functions, 'getLeaderboard');
  const result = await fn();
  return result.data;
};

export const getReportWeeks = async () => {
  const fn = httpsCallable(functions, 'getReportWeeks');
  const result = await fn();
  return result.data;
};
